import usersCreateComponent from './users-create.component';

const usersCreateModule = angular
  .module('usersCreate', [])
  .component('usersCreate', usersCreateComponent);

export default usersCreateModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-create/users-create.js
 **/